<template>
  <div class="publicMain">
    <div class="mianbao">
      <!--  -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '#' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>养老服务机构</el-breadcrumb-item>
        <el-breadcrumb-item>居家养老</el-breadcrumb-item>
        <el-breadcrumb-item>服务项目</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="服务项目">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="add" size="medium">新增</el-button>
      <el-button type="primary" @click="addClassify" size="medium">新增分类</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :width="item.type=='button'?300:''"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'" style="width:300px">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <el-button type="primary" size="mini" @click="check(scope.row)">查看</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <el-button type="success" size="mini" @click="compile(scope.row)">编辑</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                <el-button type="danger" size="mini" @click="remove(scope.row)">删除</el-button>
              </el-tooltip>

              <el-button
                type="success"
                size="mini"
                @click="pass(scope.row)"
                v-if="scope.row.state==2"
              >启用</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="unpass(scope.row)"
                v-if="scope.row.state==1"
              >禁用</el-button>
            </div>
            <div v-if="item.type=='state'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row[item.prop]==1" type="success">启用</el-tag>
                <el-tag v-if="scope.row[item.prop]==2" type="danger">禁用</el-tag>
              </div>
            </div>

            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible" width="50%">
      <div>
        <serveProjectDialog
          :buttonType="buttonType"
          :row="row"
          @save="save"
          @cancel="cancel"
          v-if="visible"
        />
      </div>
    </el-dialog>
    <!--  -->
    <el-dialog :title="title" :visible.sync="visibleShow" width="50%">
      <div class="slot">
        <serveProjectClassify v-if="visibleShow" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  oldManOrganizationserveProjectList,
  oldManOrganizationserveProjectEdit,
  oldManOrganizationserveProjectDelete,
} from "./api";
import serveProjectDialog from "./components/serveProjectDialog.vue";
import serveProjectClassify from "./components/serveProjectClassify.vue";
export default {
  components: {
    serveProjectDialog,
    serveProjectClassify,
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      title: "", //dialog的标题
      visible: false, //dialog的标题
      //模糊查询数据
      form: {
        user: "",
        region: "",
      },
      visibleShow: false, //
      //table表格的column
      tableColumn: [
        {
          prop: "serviceProjectName",
          label: "服务项目",
        },
        {
          prop: "projextExplain",
          label: "项目说明",
        },
        {
          prop: "cost",
          label: "收费标准",
        },
        {
          type: "state",
          prop: "state",
          label: "状态",
        },
        {
          type: "button",
          label: "操作",
        },
      ],
      //table表格的数据
      tableData: [],
      buttonType: false,
      row: {},
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
    };
  },
  methods: {
    //查询
    onCheck() {
      this.serveProjectListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form,
      });
      this.$message({
        message: "查询成功",
        type: "success",
      });
    },
    //重置
    onReset() {
      this.form = {};
      this.serveProjectListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      this.$message({
        message: "重置成功",
        type: "success",
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.serveProjectListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.serveProjectListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      });
    },
    //新增按钮
    add() {
      this.visible = true;
      this.buttonType = "add";
      this.title = "新增";
    },
    //拿到列表
    serveProjectListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      oldManOrganizationserveProjectList(params).then((res) => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //取消按钮
    cancel() {
      this.visible = false;
      this.serveProjectListAPI();
    },
    //查看
    check(e) {
      this.buttonType = "check";
      this.row = e;
      this.visible = true;
      this.title = "查看";
    },
    //编辑
    compile(e) {
      this.buttonType = "compile";
      this.row = e;
      this.visible = true;
      this.title = "编辑";
    },
    //删除
    remove(e) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          oldManOrganizationserveProjectDelete({ id: e.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.serveProjectListAPI({
              pageNo: 1,
              pageSize: 10,
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //审核
    audit(e) {
      this.buttonType = "audit";
      this.row = e;
      this.visible = true;
      this.title = "审核";
    },
    //保存按钮
    save(e, type = "保存") {
      console.log("保存", e);
      oldManOrganizationserveProjectEdit(e).then((res) => {
        this.$message({
          message: type + "成功",
          type: "success",
        });
        this.visible = false;
        this.serveProjectListAPI({
          pageNo: 1,
          pageSize: 10,
        });
      });
    },
    //新增分类
    addClassify() {
      this.visibleShow = true;
      this.title = "新增分类";
    },
    //通过
    pass(row) {
      this.$confirm("确认启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          oldManOrganizationserveProjectEdit({ id: row.id, state: 1 }).then(
            (res) => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.serveProjectListAPI({
                pageNo: 1,
                pageSize: 10,
              });
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //不通过
    unpass(row) {
      this.$confirm("确认禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          oldManOrganizationserveProjectEdit({ id: row.id, state: 2 }).then(
            (res) => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.serveProjectListAPI({
                pageNo: 1,
                pageSize: 10,
              });
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
  created() {
    this.serveProjectListAPI({
      pageNo: 1,
      pageSize: 10,
    });
  },
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  margin-top: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
</style>
